import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    borderRadius: '12px',
    border: '2px solid #FFF',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)',
    padding: '16px 27px',
  },
  mainTitle: {
    color: 'red',
  },
  container: {
    border: `1px solid ${theme.palette.grey.grey100}`,
    background: 'rgba(242, 243, 247, 0.20)',
    margin: '14px 26px',
    padding: '16px',
    maxHeight: '200px',
    overflow: 'auto',
  },
  toMainContextButton: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '18px',
    right: '31px',
    fontSize: '16px',
    color: theme.palette.grey.grey400,
    fontWeight: 600,
    cursor: 'pointer',
    '& span': {
      marginRight: '9px'
    }
  }
}));

export default useStyles;
